var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIconsSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.983,
    height: 13.563,
    viewBox: "0 0 12.983 13.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.327-3.618,12.162-4.29a5.267,5.267,0,0,0,0-1.92l1.165-.673a.33.33,0,0,0,.15-.383,6.81,6.81,0,0,0-1.5-2.587.329.329,0,0,0-.4-.063l-1.165.673A5.16,5.16,0,0,0,8.75-10.2v-1.343a.328.328,0,0,0-.257-.32,6.874,6.874,0,0,0-2.986,0,.328.328,0,0,0-.257.32V-10.2a5.323,5.323,0,0,0-1.662.96L2.425-9.912a.325.325,0,0,0-.4.063,6.769,6.769,0,0,0-1.5,2.587.327.327,0,0,0,.15.383l1.165.673a5.267,5.267,0,0,0,0,1.92L.675-3.615a.33.33,0,0,0-.15.383,6.81,6.81,0,0,0,1.5,2.587.329.329,0,0,0,.4.063L3.59-1.255A5.16,5.16,0,0,0,5.253-.3V1.05a.328.328,0,0,0,.257.32,6.874,6.874,0,0,0,2.986,0,.328.328,0,0,0,.257-.32V-.3a5.323,5.323,0,0,0,1.663-.96l1.165.673a.325.325,0,0,0,.4-.063,6.769,6.769,0,0,0,1.5-2.587A.338.338,0,0,0,13.327-3.618ZM7-3.062A2.19,2.19,0,0,1,4.813-5.25,2.19,2.19,0,0,1,7-7.437,2.19,2.19,0,0,1,9.188-5.25,2.19,2.19,0,0,1,7-3.062Z",
    transform: "translate(-0.51 12.029)",
    fill: "#888075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconsSettings);
export default __webpack_public_path__ + "static/media/navIcons_Settings.edae9690.svg";
export { ForwardRef as ReactComponent };